import { render, staticRenderFns } from "./AutomatedRemediationSettings.vue?vue&type=template&id=3525c45f&scoped=true"
import script from "./AutomatedRemediationSettings.vue?vue&type=script&lang=js"
export * from "./AutomatedRemediationSettings.vue?vue&type=script&lang=js"
import style0 from "./AutomatedRemediationSettings.vue?vue&type=style&index=0&id=3525c45f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525c45f",
  null
  
)

export default component.exports